import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "client-filter-modal" }
const _hoisted_2 = { class: "client-filter-modal__search" }
const _hoisted_3 = { class: "client-filter-modal__header" }
const _hoisted_4 = { class: "client-filter-modal__header-title" }
const _hoisted_5 = {
  class: "client-filter-modal__body-item",
  "data-filter-client-id": "-1",
  "data-filter-union": "0"
}
const _hoisted_6 = ["data-filter-client-id", "data-filter-union"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "client-filter-modal__body-item-holding"
}
const _hoisted_9 = ["data-filter-client-id"]
const _hoisted_10 = ["onClick"]

import {
	computed,
	nextTick,
	onMounted,
	ref,
	watch
} from "vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import {
	searchStore,
	ClientFilterOption,
	ClientFilterUnion
} from "@/store/search";

const HIGHLIGHT_CLASS = 'client-filter-modal__body-item--highlight'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectClientFilterDropdown',
  props: {
    focusClient: {}
  },
  emits: ['change', 'close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $input = ref<typeof AppInput | null>(null)
const $body = ref<HTMLDivElement | null>(null)

const store = searchStore()

const filter = ref('')

const isLoading = computed(() => store.isClientFilterLoading)

// Верхнеуровневая строка отмечена, когда выбран «холдинг целиком»; у клиента без холдинга
// такая запись хранится с UseUnion=false, потому что холдинга у неё нет.
const isOptChecked = (opt: ClientFilterOption) =>
	store.selectedClients.some(c => c.Id === opt.Id && c.UseUnion === (opt.Union.length > 0))

// Вложенный отмечен и сам по себе, и когда опция схлопнута в «холдинг целиком».
const isMemberChecked = (opt: ClientFilterOption, memberId: number) =>
	store.selectedClients.some(c => c.Id === memberId && !c.UseUnion)
	|| store.selectedClients.some(c => c.Id === opt.Id && c.UseUnion)

const filteredOptions = computed<ClientFilterOption[]>(() => {
	const query = filter.value.trim().toLowerCase()
	if (!query) {
		return store.clientFilterList
	}

	return store.clientFilterList.filter(opt =>
		opt.Name?.toLowerCase().includes(query)
		|| opt.Union.some(m => m.Name?.toLowerCase().includes(query))
	)
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const onToggleByBase = (on: boolean) => {
	store.setByBase(on)
	emit('change')
}

const onToggleClient = (opt: ClientFilterOption, on: boolean) => {
	store.toggleFilterOption(opt, on)
	emit('change')
}

const onToggleUnion = (opt: ClientFilterOption, member: ClientFilterUnion, on: boolean) => {
	store.toggleFilterMember(opt, member, on)
	emit('change')
}

const findRow = (req: { Id: number, UseUnion: boolean }) => {
	const container = $body.value
	if (!container) {
		return null
	}
	// один Id может встречаться дважды: верхнеуровневая строка «с холдингом» и вложенный
	// участник холдинга — поэтому ищем по паре атрибутов, а по одному Id только как фолбэк
	const exact = container.querySelector<HTMLElement>(
		`[data-filter-client-id="${req.Id}"][data-filter-union="${req.UseUnion ? 1 : 0}"]`
	)
	return exact ?? container.querySelector<HTMLElement>(`[data-filter-client-id="${req.Id}"]`)
}

const focusRow = async () => {
	const req = props.focusClient
	if (!req) {
		return
	}
	await nextTick()
	let el = findRow(req)
	if (!el && filter.value) {
		filter.value = ''
		await nextTick()
		el = findRow(req)
	}
	const container = $body.value
	if (!el || !container) {
		return
	}

	const cRect = container.getBoundingClientRect()
	const eRect = el.getBoundingClientRect()
	container.scrollTop += (eRect.top - cRect.top) - (container.clientHeight - el.clientHeight) / 2

	const target = el
	target.classList.remove(HIGHLIGHT_CLASS)
	target.getBoundingClientRect()
	target.classList.add(HIGHLIGHT_CLASS)
	const onEnd = () => {
		target.classList.remove(HIGHLIGHT_CLASS)
		target.removeEventListener('animationend', onEnd)
	}
	target.addEventListener('animationend', onEnd)
}

watch(() => props.focusClient, focusRow)

onMounted(async () => {
	await nextTick(() => $input.value?.focusInput())
	focusRow()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppInput, {
        ref_key: "$input",
        ref: $input,
        modelValue: filter.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
        class: "client-filter-modal__search-input",
        placeholder: _ctx.$t('search_short'),
        "show-search-button": ""
      }, null, 8, ["modelValue", "placeholder"]),
      _createElementVNode("button", {
        class: "client-filter-modal__close",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
      }, [
        _createVNode(AppIcon, {
          name: "close",
          width: "20px",
          color: "#979797"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('clients_label')), 1)
    ]),
    _createElementVNode("div", {
      class: "client-filter-modal__body",
      ref_key: "$body",
      ref: $body
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(AppCheckbox, {
          style: { height: '16px', marginRight: '8px' },
          value: _unref(store).byBase,
          text: "",
          onInput: onToggleByBase
        }, null, 8, ["value"]),
        _createElementVNode("div", {
          class: "client-filter-modal__body-item-text",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onToggleByBase(!_unref(store).byBase)))
        }, _toDisplayString(_ctx.$t('search_by_base')), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (opt) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: opt.Id
        }, [
          _createElementVNode("div", {
            class: "client-filter-modal__body-item",
            "data-filter-client-id": opt.Id,
            "data-filter-union": opt.Union.length ? 1 : 0
          }, [
            _createVNode(AppCheckbox, {
              style: { height: '16px', marginRight: '8px' },
              value: isOptChecked(opt),
              text: "",
              onInput: (on) => onToggleClient(opt, on)
            }, null, 8, ["value", "onInput"]),
            _createElementVNode("div", {
              class: "client-filter-modal__body-item-text",
              onClick: ($event: any) => (onToggleClient(opt, !isOptChecked(opt)))
            }, [
              _createTextVNode(_toDisplayString(opt.Name), 1),
              (opt.Union.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " " + _toDisplayString(_ctx.$t('with_holding_suffix')), 1))
                : _createCommentVNode("", true)
            ], 8, _hoisted_7)
          ], 8, _hoisted_6),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opt.Union, (member) => {
            return (_openBlock(), _createElementBlock("div", {
              key: member.Id,
              class: "client-filter-modal__body-item client-filter-modal__body-item--union",
              "data-filter-client-id": member.Id,
              "data-filter-union": "0"
            }, [
              _createVNode(AppCheckbox, {
                style: { height: '16px', marginRight: '8px' },
                value: isMemberChecked(opt, member.Id),
                text: "",
                onInput: (on) => onToggleUnion(opt, member, on)
              }, null, 8, ["value", "onInput"]),
              _createElementVNode("div", {
                class: "client-filter-modal__body-item-text",
                onClick: ($event: any) => (onToggleUnion(opt, member, !isMemberChecked(opt, member.Id)))
              }, _toDisplayString(member.Name), 9, _hoisted_10)
            ], 8, _hoisted_9))
          }), 128))
        ], 64))
      }), 128))
    ], 512)
  ]))
}
}

})